import { Participant } from "./participant";
import { AgendaSpeaker } from "./agenda-speaker";

import { DatexPipe } from "../pipes/datex/datex";

import * as moment from "moment";

export class SpeakerQuestion {
    id: number;
    agenda_speaker_id: number;
    participant_id: number;
    question: string;
    created_at: string;
    date_created_at: Date = new Date();
    status: number = 0;
    anonymous = false;
    participant: Participant;
    agenda_speaker: AgendaSpeaker;

    done: boolean = false;
    removed: boolean = false;


    public static STATUS_CREATED = 0;
    public static STATUS_APPROVED = 1;
    public static STATUS_DONE = 2;
    public static STATUS_REFUSED = 3;
    public static STATUS_DELETED = 4;

    /**
     * constructor
     *
     * @return void
     */
    public constructor(init?: SpeakerQuestion) {
        if (!!init) {
            Object.assign(this, init);
            this.date_created_at = moment.utc(this.created_at).toDate();
            this.participant = new Participant(this.participant);
            this.agenda_speaker = new AgendaSpeaker(this.agenda_speaker);
        }
        else {
            const datePipe = new DatexPipe();
            this.created_at = datePipe.transform(this.date_created_at, 'YYYY-MM-DD HH:mm:ss');
        }
    }
}
